import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    service: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {
      service: this.props.service,
    };
  },
  onError() {
    var updated = this.state.service;
    updated.og_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      service: updated,
    });
  },
  render() {
    var service = this.state.service;
    return (
      <div className="touch-box" style={{ width: "220px" }}>
        <article className="circle-box" style={{ height: "100%" }}>
          <a
            className="timeline_circle-link"
            href={`https://${service.subdomain}.tunagate.com`}
            target="_blank"
            rel="noreferrer"
          >
            <div
              className="timeline_circle-image"
              style={{ height: "110px", width: "100%" }}
            >
              <img
                src={service.og_image_url}
                alt={service.name}
                onError={this.onError}
                style={{ height: "100%", width: "auto" }}
              />
            </div>
            <div className="timeline_circle-description">
              <h3 className="line-2 font-size-14">
                {service.short_service_title}
              </h3>
              <h4 className="line-2 font-size-10">{service.name}</h4>
              <p className="font-size-10 color-main-strong">{service.genre}</p>
            </div>
          </a>
        </article>
      </div>
    );
  },
});
